package com.milta.core.localization

data class TeamStrings(
    val screenTitle: String,
    val statusActive: String,
    val errorGeneric: String,
    val monthNames: List<String>,
    // MIL-49 — Enterprise-side team management screen (EnterpriseTeamScreen), distinct from the
    // Driver-only "my organisations" screen above.
    val enterpriseSectionLabel: String,
    val enterpriseEmptyHint: String,
    val noEnterpriseFound: String,
    // MIL-49 — web dashboard team table column headers (WebTeamScreen).
    val columnHeaderDriver: String,
    val columnHeaderStatus: String,
    val columnHeaderActions: String,
    val addDriverSectionTitle: String,
    val addDriverCodePlaceholder: String,
    val addDriverButton: String,
    val addDriverErrorInvalidCode: String,
    val addDriverErrorNotFound: String,
    val addDriverErrorAlreadyMember: String,
    // MIL-17/MIL-49: backend rejects linking an account that itself carries Role.Enterprise
    // (error.conflict.linked_account_is_enterprise) — see LinkDriverHandler.cs.
    val addDriverErrorLinkedAccountIsEnterprise: String,
    // An Enterprise has at most 10 active members, Patron included: linking an 11th is refused (409).
    val addDriverErrorLimitReached: String,
    // Linking a Driver is refused (409) while the Enterprise's own subscription is not valid.
    val addDriverErrorEnterpriseSubscriptionInactive: String,
    // MIL-49 — DriverDetailScreen (reached by tapping a driver in EnterpriseTeamScreen).
    val driverDetailTitle: String,
    val driverDetailPhoneLabel: String,
    val removeDriverButton: String,
    val removeDriverDialogTitle: String,
    val removeDriverDialogMessagePrefix: String,
    val removeDriverDialogMessageSuffix: String,
    val removeDriverErrorNotFound: String,
    val removeDriverErrorOnActiveDelivery: String,
    val removeDriverErrorLastOwner: String,
)
